import { render, staticRenderFns } from "./hoverSide.vue?vue&type=template&id=8f96f72e"
import script from "./hoverSide.vue?vue&type=script&lang=js"
export * from "./hoverSide.vue?vue&type=script&lang=js"
import style0 from "./hoverSide.vue?vue&type=style&index=0&id=8f96f72e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports